<template>
  <div class="head">
    <div class="w">
      <div class="left">
        <div class="logo" @click="$router.push('/')"></div>
        <div class="xb_img" v-if="departmentShow">
          <img
            v-if="this.$route.query.articleModel == '1201'"
            src="../assets/imgs/xb1.png"
            alt=""
          />
          <img
            v-if="this.$route.query.articleModel == '1202'"
            src="../assets/imgs/xb2.png"
            alt=""
          />
          <img
            v-if="this.$route.query.articleModel == '1203'"
            src="../assets/imgs/xb3.png"
            alt=""
          />
          <img
            v-if="this.$route.query.articleModel == '1204'"
            src="../assets/imgs/xb4.png"
            alt=""
          />
          <img
            v-if="this.$route.query.articleModel == '1205'"
            src="../assets/imgs/xb5.png"
            alt=""
          />
          <img
            v-if="this.$route.query.articleModel == '1206'"
            src="../assets/imgs/xb6.png"
            alt=""
          />
          <img
            v-if="this.$route.query.articleModel == '1207'"
            src="../assets/imgs/xb7.png"
            alt=""
          />
          <img
            v-if="this.$route.name == 'LibraryContent'"
            src="../assets/imgs/xb8.png"
            alt=""
            class="library"
          />
        </div>
      </div>

      <div class="tools">
        <div class="link">
          <span @click="addSave">加入收藏</span>
          <span @click="$router.push('/')">回到首页</span>
        </div>
        <input type="text" placeholder="请输入搜索内容" />
        <div class="search_btn">搜索</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Head",
  data() {
    return {
      departmentShow: false
    };
  },
  watch: { $route: "changeStyle" },
  methods: {
    addSave() {
      alert("请使用Ctrl+D进行收藏");
    },
    changeStyle() {
      let path = this.$route.path;
      if (path === "/department" || path === "/library") {
        this.departmentShow = true;
      }
    }
  }
};
</script>
<style scoped>
.head {
  height: 140px;
  background-image: linear-gradient(
      to right,
      rgba(5, 115, 184, 0.8),
      rgba(181, 204, 255, 0.8)
    ),
    url("../assets/imgs/headimg1.jpeg");
  background-position: center;
  background-size: cover;
  transition: height 0.5s;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
}
.head > .w {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.head .left {
  display: flex;
}
.xb_img > img {
  height: 70px;
  width: auto;
}
.logo {
  height: 90px;
  width: 500px;
  background-image: url("../assets/imgs/logo1.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.tools {
  width: 300px;
  height: 42px;
  position: relative;
  display: flex;
}
.tools > .link {
  position: absolute;
  top: -25px;
  display: flex;
  width: 240px;
  user-select: none;
}
.link > span {
  flex: 1;
  text-align: center;
  color: rgb(5, 115, 184);
  cursor: pointer;
}
.tools > input {
  flex: 1;
  outline: 0;
  border: 2px solid rgb(5, 115, 184);
  border-radius: 5px 0 0 5px;
  background: transparent;
}
.tools > .search_btn {
  width: 60px;
  background-color: rgb(5, 115, 184);
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 14px;
  color: #f9f0da;
  line-height: 42px;
  text-align: center;
  user-select: none;
}

.library {
  transform: translate(-60px);
}

@media screen and (max-width: 768px) {
  .tools {
    display: none !important;
  }
  .logo {
    width: 350px;
  }

  .head > .w {
    /* display: none; */
  }
  /* .head>.w {
            display: block;
            height: 240px;
            line-height: 240px;

        } */
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue